<template>
  <span class="read-more">{{ ' ' }}<a :href="linkUrl">{{ moreText }}&nbsp;→</a></span>
</template>

<script>
  // The leading space in the template is explicit ({{ ' ' }}): Vue 3 condenses template
  // whitespace, and the old build rendered a space before the link.
  export default {
    name: 'ReadMore',
    props: {
      linkUrl: { type: String, default: '' },
      lang: { type: String, default: 'en' },
    },
    computed: {
      moreText() {
        return this.lang === 'en' ? 'Read more' : 'Weiter lesen'
      },
    },
  }
</script>

<style>
  .read-more > a {
    white-space: pre;
  }
</style>
